import { InputAdornment } from "@mui/material";

import { FormatType } from "../../Alert/Filter/FilterType";
import { Industry } from "../../Industry";
import {
  ConfigurationFormType,
  ConfigurationPageTab,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_UH_CAT_PAGE_UH_GROUP_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "PRODUCT",
  path: "uh-cat-groups-1",
  // TODO: Remove separator when tab Product Master will be avaible
  separator: true,
  model: {
    entityName: "short_name",
    label: "PRODUCT",
    path: "/api/uh-cat-groups-1",
    bulkPath: "/api/uh-cat-groups-1/bulk-updates",
    name: "Uh Cat Groupe1",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
    ],
    filters: [
      {
        lookup: "search",
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/uh-cat-groups-1/export" },
    import: { path: "/api/uh-cat-groups-1/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
  },
};

// const SURQUAL_UH_CAT_PAGE_PRODUCT_MASTER_TAB: ConfigurationPageTables = {
//   description: "CONF_PAGE_DESC_DEFAULT",
//   type: ConfigurationPageType.TABLE,
//   label: "PRODUCT_MASTER",
//   path: "uh-cat-product-master",
//   separator: true,
//   model: {
//     entityName: "short_name",
//     label: "PRODUCT_MASTER",
//     path: "/api/uh-cat-product-master",
//     bulkPath: "/api/uh-cat-product-master/bulk-updates",
//     name: "Uh Cat Product Master",
//     attributes: [
//       {
//         className: "greyText",
//         key: "code",
//         order: 1,
//         label: "CODE",
//         visible: true,
//       },
//       {
//         key: "short_name",
//         order: 2,
//         label: "SHORT_NAME",
//         visible: true,
//       },
//       {
//         className: "greyText",
//         key: "name",
//         order: 3,
//         label: "LONG_NAME",
//         visible: true,
//       },
//     ],
//     filters: [
//       {
//         lookup: "search",
//         type: ConfigurationTableFilterType.Search,
//       },
//       {
//         type: ConfigurationTableFilterType.ResetButton,
//       },
//     ],
//     export: {path: "/api/uh-cat-product-master/export"},
//     import: {path: "/api/uh-cat-product-master/presign-url"},
//   },
//   options: {
//     formFields: [
//       {
//         key: "code",
//         label: "CODE",
//         type: ConfigurationFormType.Input,
//       },
//       {
//         key: "short_name",
//         label: "SHORT_NAME",
//         type: ConfigurationFormType.Input,
//       },
//       {
//         key: "name",
//         label: "LONG_NAME",
//         type: ConfigurationFormType.Input,
//       },
//     ],
//     copyable: false,
//     creatable: true,
//     createOptions: [
//       {
//         key: "code",
//         flex: "50%",
//         required: true,
//       },
//       {
//         key: "short_name",
//         flex: "50%",
//         required: true,
//       },
//       {
//         key: "name",
//         flex: "100%",
//         required: true,
//       },
//     ],
//     deletable: true,
//     editable: true,
//     editOptions: [
//       {
//         key: "code",
//         flex: "50%",
//         required: true,
//       },
//       {
//         key: "short_name",
//         flex: "50%",
//         required: true,
//       },
//       {
//         key: "name",
//         flex: "100%",
//         required: true,
//       },
//     ],
//   },
// };

const SURQUAL_UH_CAT_PAGE_UH_TYPE_GROUP_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "UH_TYPE_MASTER",
  path: "uh-type-groups-1",
  separator: true,
  model: {
    entityName: "short_name",
    label: "UH_TYPE_MASTER",
    path: "/api/uh-type-groups-1",
    name: "Uh Type Groupe1",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
    ],
    filters: [
      {
        lookup: "search",
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/uh-type-groups-1/export" },
    import: { path: "/api/uh-type-groups-1/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
    ],
  },
};

const SURQUAL_UH_CAT_PAGE_UH_TYPE_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "UH_TYPE",
  path: "uh-types",
  model: {
    entityName: "short_name",
    label: "UH_TYPE",
    path: "/api/uh-types",
    bulkPath: "/api/uh-types/bulk-updates",
    name: "Uh Type",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        align: "right",
        key: "order",
        order: 4,
        label: "RANK",
        visible: true,
        type: FormatType.NUMBER,
      },
      {
        key: "group1.short_name",
        order: 5,
        label: "UH_TYPE_MASTER",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/uh-types/export" },
    import: { path: "/api/uh-types/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        label: "UH_TYPE_MASTER",
        type: ConfigurationFormType.Select,
        api: "/api/uh-type-groups-1/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group1",
        labelKey: "short_name",
        subCreationForm: SURQUAL_UH_CAT_PAGE_UH_TYPE_GROUP_TAB,
      },
      {
        inputType: "integer",
        key: "order",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
      {
        key: "separatorQualification",
        label: "QUALIFICATION",
        type: ConfigurationFormType.Separator,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "100%",
      },
      {
        key: "order",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "separatorQualification",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "100%",
      },
      {
        key: "order",
        flex: "50%",
      },
    ],
    editSelectedOptions: [
      {
        key: "group1",
        flex: "100%",
      },
    ],
    rankable: {
      column: "order",
      watchLookup: "property",
    },
  },
};

const SURQUAL_UH_CAT_PAGE_UH_TYPE_NANDC_TAB: ConfigurationPageTables = {
  description: "CONF_PAGE_DESC_DEFAULT",
  type: ConfigurationPageType.TABLE,
  label: "UHTYPE_NC",
  path: "uh-types-nandc",
  model: {
    entityName: "short_name",
    label: "UHTYPE_NC",
    path: "/api/uh-types-nandc",
    bulkPath: "/api/uh-types-nandc/bulk-updates",
    name: "Uh Type Nandc",
    attributes: [
      {
        className: "greyText",
        key: "code",
        order: 1,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 2,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 3,
        label: "LONG_NAME",
        visible: true,
      },
      {
        align: "right",
        key: "order",
        order: 4,
        label: "RANK",
        visible: true,
        type: FormatType.NUMBER,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/uh-types-nandc/export" },
    import: { path: "/api/uh-types-nandc/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "integer",
        key: "order",
        label: "RANK",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "order",
        flex: "50%",
      },
    ],
    deletable: true,
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "order",
        flex: "50%",
      },
    ],
    rankable: {
      column: "order",
    },
  },
};

const SURQUAL_UH_CAT_PAGE_UH_CAT_TAB: ConfigurationPageTables = {
  description: "CONF_DESC_SELFMAPPING_UH_CAT",
  type: ConfigurationPageType.TABLE,
  label: "UH_CAT",
  path: "",
  separator: true,
  model: {
    dynamicPath: true,
    entityName: "short_name",
    label: "UH_CAT",
    path: "/api/uh-cats",
    bulkPath: "/api/uh-cats/bulk-updates",
    name: "Uh Cat",
    enableTableColumnMenu: true,
    attributes: [
      {
        key: "property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        className: "greyText",
        key: "code",
        order: 2,
        label: "CODE",
        visible: true,
      },
      {
        key: "short_name",
        order: 3,
        label: "SHORT_NAME",
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 3,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 4,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 5,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        className: "greyText separationColumnRight",
        headerClassName: "separationColumnRight",
        key: "name",
        order: 4,
        label: "LONG_NAME",
        visible: false,
        hideable: true,
      },
      {
        key: "is_property_reference",
        order: 5,
        label: "PROPERTY_REF",
        type: FormatType.BOOLEAN,
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        key: "uh_type_nandc.short_name",
        order: 6,
        label: "UHTYPE_NC",
        visible: true,
      },
      {
        key: "is_uh_type_reference",
        order: 7,
        label: "UHTYPE_NC_REF",
        type: FormatType.BOOLEAN,
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        key: "product_nandc.short_name",
        order: 8,
        label: "PRODUCT_NANDC",
        visible: false,
        hideable: true,
      },
      {
        key: "is_connected",
        order: 9,
        label: "COMMUNICATIVE",
        type: FormatType.BOOLEAN,
        visible: false,
        hideable: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
        ],
      },
      {
        className: "separationColumnLeft",
        headerClassName: "separationColumnLeft",
        key: "is_active",
        order: 10,
        label: "UH_CAT_TO_EXCLUDED",
        type: FormatType.BOOLEAN,
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "error.main",
            },
          },
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
        ],
      },
      // to_import: hidden — no backend logic reads this flag yet
      // {
      //   key: "to_import",
      //   order: 11,
      //   label: "TO_IMPORT",
      //   type: FormatType.BOOLEAN,
      //   visible: false,
      //   hideable: true,
      //   rules: [
      //     {
      //       type: "compare-with",
      //       value: true,
      //       operator: "eq",
      //       options: {
      //         color: "text.cell",
      //       },
      //     },
      //     {
      //       type: "compare-with",
      //       value: false,
      //       operator: "eq",
      //       options: {
      //         color: "error.main",
      //       },
      //     },
      //   ],
      // },
      {
        key: "is_turnover_active",
        order: 12,
        label: "CA_IS_ACTIVE",
        type: FormatType.BOOLEAN,
        visible: false,
        hideable: true,
        rules: [
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "error.main",
            },
          },
        ],
      },
      {
        key: "is_occupation_active",
        order: 13,
        label: "NIGHT_IS_ACTIVE",
        type: FormatType.BOOLEAN,
        visible: true,
        rules: [
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "error.main",
            },
          },
        ],
      },
      {
        key: "is_capacity_active",
        order: 14,
        label: "CAPACITY_IS_ACTIVE",
        type: FormatType.BOOLEAN,
        visible: false,
        hideable: true,
        rules: [
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "error.main",
            },
          },
        ],
      },
      {
        key: "to_price",
        order: 15,
        label: "TO_PRICE",
        type: FormatType.BOOLEAN,
        visible: false,
        hideable: true,
        rules: [
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "error.main",
            },
          },
        ],
      },
      {
        className: "separationColumnLeft",
        headerClassName: "separationColumnLeft",
        align: "right",
        key: "order",
        order: 16,
        label: "RANK",
        visible: true,
        type: FormatType.NUMBER,
      },
      {
        key: "uh_type.short_name",
        order: 17,
        label: "UH_TYPE",
        visible: true,
      },
      {
        key: "group1.short_name",
        order: 18,
        label: "PRODUCT",
        visible: false,
        hideable: true,
      },
      {
        key: "nb_rooms",
        order: 19,
        label: "NB_ROOMS",
        visible: false,
        includedIndustries: [Industry.CAMPING],
        hideable: true,
      },
      {
        key: "nb_adult_pax",
        order: 20,
        label: "NB_ADULT_PAX",
        visible: false,
        hideable: true,
      },
      {
        align: "right",
        key: "day_of_arrival",
        order: 21,
        label: "ARRIVAL_DAY",
        visible: false,
        type: FormatType.WEEKDAYS,
        hideable: true,
      },
      {
        key: "range",
        order: 22,
        label: "GAMME",
        visible: false,
        hideable: true,
      },
      {
        key: "surface",
        order: 23,
        label: "SURFACE",
        visible: false,
        hideable: true,
      },
      {
        key: "target_population",
        order: 24,
        label: "TARGET_POPULATION",
        visible: false,
        hideable: true,
      },
      {
        key: "equipment",
        order: 25,
        label: "EQUIPMENT",
        visible: false,
        includedIndustries: [Industry.CAMPING],
        hideable: true,
      },
      {
        key: "has_prm_access",
        order: 26,
        label: "PRM",
        type: FormatType.BOOLEAN,
        visible: false,
        hideable: true,
        rules: [
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
        ],
      },
      {
        key: "has_air_conditioning",
        order: 27,
        includedIndustries: [Industry.CAMPING],
        label: "AIR_CONDITIONING",
        type: FormatType.BOOLEAN,
        visible: false,
        hideable: true,
        rules: [
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
        ],
      },
      {
        key: "has_terrace",
        order: 28,
        label: "TERRACE",
        includedIndustries: [Industry.CAMPING],
        type: FormatType.BOOLEAN,
        visible: false,
        hideable: true,
        rules: [
          {
            type: "compare-with",
            value: true,
            operator: "eq",
            options: {
              color: "text.accent",
            },
          },
          {
            type: "compare-with",
            value: false,
            operator: "eq",
            options: {
              color: "text.cell",
            },
          },
        ],
      },
      {
        key: "location",
        order: 29,
        includedIndustries: [Industry.CAMPING, Industry.CRUISE, Industry.HOTEL],
        label: "LOCATION",
        visible: false,
        hideable: true,
      },
      {
        key: "service_client_names",
        order: 30,
        label: "SERVICE_CLIENTS",
        visible: false,
        hideable: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/uh-cats/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Select,
        // Must finish with a `/`
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "hebergement_nom_court",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "property",
        usefulForRankability: true,
      },
      {
        lookup: "search",
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/uh-cats/export" },
    import: { path: "/api/uh-cats/presign-url" },
  },
  options: {
    formFields: [
      {
        key: "code",
        label: "CODE",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        watchedBy: "connecting_rooms[].uh_cat_connected",
        watchLookup: "property",
      },
      {
        key: "short_name",
        label: "SHORT_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "name",
        label: "LONG_NAME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "is_property_reference",
        label: "PROPERTY_REF",
        type: ConfigurationFormType.Check,
      },
      {
        label: "UHTYPE_NC",
        type: ConfigurationFormType.Select,
        api: "/api/uh-types-nandc/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "uh_type_nandc",
        labelKey: "short_name",
        subCreationForm: SURQUAL_UH_CAT_PAGE_UH_TYPE_NANDC_TAB,
      },
      {
        key: "is_uh_type_reference",
        label: "UHTYPE_NC_REF",
        type: ConfigurationFormType.Check,
      },
      {
        label: "PRODUCT_NANDC",
        type: ConfigurationFormType.Select,
        api: "/api/product-nandc/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "product_nandc",
        labelKey: "short_name",
      },
      {
        key: "is_connected",
        label: "COMMUNICATIVE",
        type: ConfigurationFormType.Check,
      },
      {
        key: "connecting_rooms",
        type: ConfigurationFormType.FieldGroupColumn,
        limit: null,
        limitMin: 1,
        limitDefault: 2,
        label: "CREATE_CONNECTING_ROOM",
        buttonLabel: null,
        removeButtonDisplay: "inline",
        relatedInputAction: {
          action: "show",
          relatedInput: "is_connected",
        },
        sumPercentLimit: ["ratio_ca", "ratio_pax"],
        autoFillPercent: ["ratio_ca", "ratio_pax"],
        columns: [
          {
            key: "column-1",
            columnLabel: "CONNECTING_ROOM_UH_CAT",
            fields: [
              {
                type: ConfigurationFormType.Select,
                api: "/api/uh-cats/",
                apiParams: {
                  page_size: 100,
                  ordering: "short_name",
                },
                key: "uh_cat_connected",
                labelKey: "short_name",
                label: "UH_CAT",
                watchField: [
                  {
                    paramsKey: "property",
                    paramsValue: "id",
                    watchFieldPath: "property",
                  },
                ],
              },
            ],
          },
          {
            key: "column-2",
            columnLabel: "CONNECTING_ROOM_VENTILATION",
            columnTooltip: "CONNECTING_ROOM_VENTILATION_TOOLTIP",
            fields: [
              {
                key: "ratio_ca",
                label: "REVENUE_ABBREVIATION",
                inputType: "percent",
                inputProps: {
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                },
                type: ConfigurationFormType.Input,
              },
              {
                key: "nb_uh",
                label: "CONNECTING_ROOM_NIGHT",
                inputType: "integer",
                defaultValue: "1",
                inputProps: {
                  type: "number",
                  inputProps: {
                    min: 0,
                    step: "1",
                  },
                },
                type: ConfigurationFormType.Input,
              },
              {
                key: "ratio_pax",
                label: "CONNECTING_ROOM_PAX",
                inputType: "percent",
                inputProps: {
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                },
                type: ConfigurationFormType.Input,
              },
            ],
          },
        ],
      },
      {
        key: "separatorAlgorithmic",
        label: "SEPARATOR_REVBELL_DATA_USE",
        type: ConfigurationFormType.Separator,
      },
      {
        type: ConfigurationFormType.Text,
        key: "manage_data",
        label: "MANAGE_DATA_TEXT",
        sx: {
          textAlign: "left",
          fontStyle: "normal",
          mt: -1,
          mb: -2,
        },
      },
      {
        type: ConfigurationFormType.Text,
        key: "manage_data_description",
        label: "MANAGE_DATA_DESCRIPTION",
        sx: {
          textAlign: "left",
          fontStyle: "italic",
          fontSize: "0.85rem",
          mt: -1,
          mb: -1,
          opacity: 0.7,
        },
      },
      // to_import: hidden — no backend logic reads this flag yet
      // {
      //   key: "to_import",
      //   label: "TO_IMPORT",
      //   type: ConfigurationFormType.Check,
      // },
      {
        key: "is_occupation_active",
        label: "DATA_USE_NIGHT",
        type: ConfigurationFormType.Check,
        defaultValue: true,
      },
      {
        key: "is_turnover_active",
        label: "DATA_USE_CA",
        type: ConfigurationFormType.Check,
        defaultValue: true,
      },
      {
        key: "is_capacity_active",
        label: "DATA_USE_CAPACITY",
        type: ConfigurationFormType.Check,
        defaultValue: true,
      },
      // {
      //   key: "pax",
      //   label: "DATA_USE_PAX",
      //   type: ConfigurationFormType.Check,
      //   defaultValue: true,
      // },
      {
        type: ConfigurationFormType.Text,
        key: "grid_type_text",
        label: "GRID_TYPE_TEXT",
        sx: {
          textAlign: "left",
          fontStyle: "normal",
          mt: -1,
          mb: -2,
        },
      },
      {
        key: "to_price",
        label: "GRID_TO_PRICE",
        type: ConfigurationFormType.Check,
        defaultValue: true,
      },
      {
        key: "separatorSpecifications",
        label: "SPECIFICATIONS",
        type: ConfigurationFormType.Separator,
      },
      {
        label: "UH_TYPE",
        type: ConfigurationFormType.Select,
        api: "/api/uh-types/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "uh_type",
        labelKey: "short_name",
        subCreationForm: SURQUAL_UH_CAT_PAGE_UH_TYPE_TAB,
      },
      {
        label: "PRODUCT",
        type: ConfigurationFormType.Select,
        api: "/api/uh-cat-groups-1/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
        },
        key: "group1",
        labelKey: "short_name",
        subCreationForm: SURQUAL_UH_CAT_PAGE_UH_GROUP_TAB,
      },
      {
        inputType: "integer",
        key: "nb_rooms",
        label: "NB_ROOMS",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CAMPING],
      },
      {
        inputType: "integer",
        key: "nb_adult_pax",
        label: "NB_ADULT_PAX",
        type: ConfigurationFormType.Input,
      },
      {
        key: "day_of_arrival",
        label: "ARRIVAL_DAY",
        type: ConfigurationFormType.DayOfWeek,
      },
      {
        key: "range",
        label: "GAMME",
        type: ConfigurationFormType.Input,
      },
      {
        key: "surface",
        label: "SURFACE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "target_population",
        label: "TARGET_POPULATION",
        type: ConfigurationFormType.Input,
      },
      {
        key: "equipment",
        label: "EQUIPMENT",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CAMPING],
      },
      {
        key: "has_prm_access",
        label: "PRM",
        type: ConfigurationFormType.Check,
      },
      {
        key: "has_air_conditioning",
        label: "AIR_CONDITIONING",
        type: ConfigurationFormType.Check,
        includedIndustries: [Industry.CAMPING],
      },
      {
        key: "has_terrace",
        label: "TERRACE",
        type: ConfigurationFormType.Check,
        includedIndustries: [Industry.CAMPING],
      },
      {
        key: "location",
        label: "LOCATION",
        type: ConfigurationFormType.Input,
        includedIndustries: [Industry.CAMPING, Industry.CRUISE, Industry.HOTEL],
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "property",
        flex: "100%",
        required: true,
      },
      {
        key: "uh_type_nandc",
        flex: "50%",
        required: true,
      },
      {
        key: "product_nandc",
        flex: "50%",
      },
      {
        key: "is_property_reference",
        flex: "33%",
      },
      {
        key: "is_uh_type_reference",
        flex: "33%",
      },
      {
        key: "is_connected",
        flex: "33%",
      },
      {
        key: "connecting_rooms",
        flex: "100%",
        columns: [
          {
            key: "column-1",
            flex: "55%",
            fields: [
              {
                key: "uh_cat_connected",
                flex: "100%",
                required: true,
              },
            ],
          },
          {
            key: "column-2",
            flex: "40%",
            fields: [
              {
                key: "ratio_ca",
                flex: "22%",
                required: true,
              },
              {
                key: "nb_uh",
                flex: "22%",
                required: true,
              },
              {
                key: "ratio_pax",
                flex: "22%",
                required: true,
              },
            ],
          },
        ],
      },
      {
        key: "separatorAlgorithmic",
        flex: "100%",
      },
      {
        key: "manage_data",
        flex: "100%",
        readonly: true,
      },
      {
        key: "manage_data_description",
        flex: "100%",
      },
      // to_import: hidden — no backend logic reads this flag yet
      // {
      //   key: "to_import",
      //   flex: "25%",
      // },
      {
        key: "is_occupation_active",
        flex: "25%",
      },
      {
        key: "is_turnover_active",
        flex: "25%",
      },
      {
        key: "is_capacity_active",
        flex: "25%",
      },
      {
        key: "grid_type_text",
        flex: "100%",
        readonly: true,
      },
      {
        key: "to_price",
        flex: "33%",
      },
      {
        key: "separatorSpecifications",
        flex: "100%",
      },
      {
        key: "uh_type",
        flex: "50%",
        required: true,
      },
      {
        key: "group1",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_rooms",
        flex: "50%",
      },
      {
        key: "nb_adult_pax",
        flex: "50%",
      },
      {
        key: "day_of_arrival",
        flex: "50%",
      },
      {
        key: "range",
        flex: "50%",
      },
      {
        key: "surface",
        flex: "50%",
      },
      {
        key: "target_population",
        flex: "50%",
      },
      {
        key: "location",
        flex: "50%",
      },
      {
        key: "equipment",
        flex: "100%",
      },
      {
        key: "has_prm_access",
        flex: "50%",
      },
      {
        key: "has_air_conditioning",
        flex: "50%",
      },
      {
        key: "has_terrace",
        flex: "50%",
      },
    ],
    editSelectedOptions: [
      {
        key: "uh_type_nandc",
        flex: "100%",
      },
      {
        key: "product_nandc",
        flex: "100%",
      },
      {
        key: "uh_type",
        flex: "100%",
      },
      {
        key: "group1",
        flex: "100%",
      },
      {
        key: "day_of_arrival",
        flex: "50%",
      },
      {
        key: "range",
        flex: "50%",
      },
    ],
    deletable: true,
    // Same reason as the property tab in SURQUAL_PROPERTY: the generic REST
    // DELETE has no notion of the dependency graph, and hebergement_uh_cat has
    // far more foreign-key children than hebergement.
    deleteTarget: "uh_cat",
    editable: true,
    editOptions: [
      {
        key: "code",
        flex: "50%",
        required: true,
      },
      {
        key: "short_name",
        flex: "50%",
        required: true,
      },
      {
        key: "name",
        flex: "100%",
        required: true,
      },
      {
        key: "property",
        visible: false,
        flex: "100%",
        required: true,
      },
      {
        key: "uh_type_nandc",
        flex: "50%",
      },
      {
        key: "product_nandc",
        flex: "50%",
      },
      {
        key: "is_property_reference",
        flex: "33%",
      },
      {
        key: "is_uh_type_reference",
        flex: "33%",
      },
      {
        key: "is_connected",
        flex: "33%",
      },
      {
        key: "connecting_rooms",
        flex: "100%",
        columns: [
          {
            key: "column-1",
            flex: "40%",
            fields: [
              {
                key: "uh_cat_connected",
                flex: "100%",
                required: true,
              },
            ],
          },
          {
            key: "column-2",
            flex: "60%",
            fields: [
              {
                key: "ratio_ca",
                flex: "22%",
                required: true,
              },
              {
                key: "nb_uh",
                flex: "22%",
                required: true,
              },
              {
                key: "ratio_pax",
                flex: "22%",
                required: true,
              },
            ],
          },
        ],
      },
      {
        key: "separatorAlgorithmic",
        flex: "100%",
      },
      {
        key: "manage_data",
        flex: "100%",
        readonly: true,
      },
      {
        key: "manage_data_description",
        flex: "100%",
      },
      // to_import: hidden — no backend logic reads this flag yet
      // {
      //   key: "to_import",
      //   flex: "25%",
      // },
      {
        key: "is_occupation_active",
        flex: "25%",
      },
      {
        key: "is_turnover_active",
        flex: "25%",
      },
      {
        key: "is_capacity_active",
        flex: "25%",
      },
      {
        key: "grid_type_text",
        flex: "100%",
        readonly: true,
      },
      {
        key: "to_price",
        flex: "33%",
      },
      {
        key: "separatorSpecifications",
        flex: "100%",
      },
      {
        key: "uh_type",
        flex: "50%",
      },
      {
        key: "group1",
        flex: "50%",
      },
      {
        key: "nb_rooms",
        flex: "50%",
      },
      {
        key: "nb_adult_pax",
        flex: "50%",
      },
      {
        key: "day_of_arrival",
        flex: "50%",
      },
      {
        key: "range",
        flex: "50%",
      },
      {
        key: "surface",
        flex: "50%",
      },
      {
        key: "target_population",
        flex: "50%",
      },
      {
        key: "location",
        flex: "50%",
      },
      {
        key: "equipment",
        flex: "100%",
      },
      {
        key: "has_prm_access",
        flex: "50%",
      },
      {
        key: "has_air_conditioning",
        flex: "50%",
      },
      {
        key: "has_terrace",
        flex: "50%",
      },
    ],
    formSize: "md",
    rankable: {
      column: "order",
      watchLookup: "property",
    },
  },
};

export const SURQUAL_UH_CAT_PAGE: ConfigurationPageTab = {
  type: ConfigurationPageType.TABS,
  count: 19,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "UH_CAT",
  pageLabel: "UH_CAT_TITLE_SURQUAL",
  menuLabel: "UH_CAT",
  name: "uh_cat",
  path: "hebergement-uhcat",
  tabs: [
    SURQUAL_UH_CAT_PAGE_UH_CAT_TAB,
    SURQUAL_UH_CAT_PAGE_UH_GROUP_TAB,
    // SURQUAL_UH_CAT_PAGE_PRODUCT_MASTER_TAB,
    SURQUAL_UH_CAT_PAGE_UH_TYPE_TAB,
    SURQUAL_UH_CAT_PAGE_UH_TYPE_GROUP_TAB,
    SURQUAL_UH_CAT_PAGE_UH_TYPE_NANDC_TAB,
  ],
};
